import * as React from 'react';
import { Input, Icon, Button, Row, Col, Alert, message, Radio } from 'antd';
// import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import util from '../common/utils';
import '../../css/Login.scss';
import service from '../../service/apolloclient.service';
import LocalStorage from '../../service/localstorage';
import { MSGDISPLAYTIME, GENERATEOTP_TYPE } from '../common/constants';
// import ReactPhoneInput from 'react-phone-input-2';
import strings from '../../eyeguide-localization/strings.login';
import Constants from '../common/constants';

const logo = require('../../images/logo.svg');
const storage = new LocalStorage();
var timer;

interface ILoginProps {
  match: any;
  location: any;
  url: any;
}

interface IloginState {
  mobileotp: string;
  emailotp: string;
  errorMobile: boolean;
  toMain: boolean;
  flag: boolean;
  check: boolean;
  errorEmail: boolean;
  errorMotp: boolean;
  errorEotp: boolean;
  loading: boolean;
  inputDisabled: boolean;
  isMobileInput: boolean;
  mobileNum: string;
  email: string;
  mobileNumFormatted: string;
  freezeInput: boolean;
  linkExpired: boolean;
  userFirstName: string;
  userLastName: string;
  userOrgName: string;
  selected: string;
  counter: number;
}

class ExternalLogin extends React.Component<ILoginProps, IloginState> {
  phoneInput: any;
  constructor(props: ILoginProps) {
    super(props);
    this.state = {
      selected: '',
      mobileotp: '',
      emailotp: '',
      mobileNum: '',
      email: '',
      toMain: false,
      flag: false,
      check: false,
      errorEmail: false,
      errorEotp: false,
      errorMotp: false,
      loading: false,
      inputDisabled: false,
      isMobileInput: true,
      errorMobile: false,
      mobileNumFormatted: '',
      freezeInput: false,
      linkExpired: false,
      userFirstName: '',
      userLastName: '',
      userOrgName: '',
      counter: 60,
    };
    this.handleOnChange = this.handleOnChange.bind(this);
    // history.pushState(null, '', document.URL);
    window.onbeforeunload = () => {
      let prevState = localStorage.getItem('loginState');
      // if (prevState !== '{}') {
      let loginState = {
        shareid: this.props.match.params.shareid,
        endTime: this.state.counter < 60 && prevState !== '{}' ?
            (Date.now() + this.state.counter * 1000) : 60,
        // isMobileInput: this.state.isMobileInput,
        isLoggedIn: false
      };
      localStorage.setItem('loginState', JSON.stringify(loginState));
      // }
    };
  }

  /**
   * Login clicked
   */
  async submit() {
    this.setState({ loading: true, inputDisabled: true});

    if (this.validateInput()) {
      let ser = new service();
      try {
        let res = await ser.externalLogin(this.props.match.params.shareuserid, 
                                          this.props.match.params.shareid,
                                          this.state.mobileotp !== null ? 
                                          this.state.mobileotp : '', 
        );
        console.log('EXTERNAL login response', res);
        if (res.status === 0) {
          this.initializeLocalstorage(res);
          this.setState({
            toMain: true
          });
          storage.setSharedId(this.props.match.params.shareid);
          storage.setSharedUserId(this.props.match.params.shareuserid);

        } else if (res.status === 1 && res.message.indexOf('User Not Active') > -1) {
          this.setState({
            freezeInput: true
          });
          message.error(strings.IsUserActive, MSGDISPLAYTIME);
        } else if (res.status === 1 && res.message.indexOf(Constants.getErrorText().ERROR_OTP_EXPIRED) > -1) {
            this.setState({ freezeInput: true});
            message.error(strings.lsOtpExpiredTxt, MSGDISPLAYTIME); 
        } else {
          this.setState({ loading: false , inputDisabled: false});
          message.error(strings.lsExternalLoginFailedTxt2, MSGDISPLAYTIME); 
        }
      } catch ( e ) {
        this.setState({ loading: false , inputDisabled: false});
        this.initializeLocalstorage({});
        console.log('EXTERNAL login error', e);
        message.error(strings.lsExternalLoginFailedTxt, MSGDISPLAYTIME); 
      }
    }
  }

  async getMobileCode() {
    if (this.validateSelectedField()) {
      this.generateOtp(GENERATEOTP_TYPE.sendOTP);
    }
  }

  validateSelectedField() {
    console.log(this.state.email, this.state.mobileNum);
    let isEmailValid = this.state.selected === 'email' ? util.validateEmail(this.state.email) : false;
    let isPhoneValid = this.state.selected === 'phone'
      ? util.validatePhone(this.state.mobileNum) : false;
    // alert('' + isEmailValid + isPhoneValid);
    this.setState({
      errorEmail: !isEmailValid,
      errorMobile: !isPhoneValid
    });
    return isEmailValid || isPhoneValid;
  }

  getFormattedValue(type: string) {
    if (type === 'email') {
      let email = this.state.email;
      if (email.split('@').length === 2) {
        
        let username = email.split('@')[0];
        let domains = email.split('@')[1].split('.');
        let domainType = domains.pop();
        let domain: any = domains.join('.');
        domain = domain.charAt(0) + new Array(domain.length - 1).join('.') + domain.slice(-1);
        username = username.charAt(0) + new Array(username.length - 1).join('.') + username.slice(-1);
        return username + `@${domain}.${domainType}`;

      } else {
        return email.charAt(0) + new Array(email.length - 1).join('.') + email.slice(-1);
      }
    }
    let phone = this.state.mobileNum;
    let part1 = phone.slice(0, phone.length - 4);
    let part2 = phone.slice(-4);
    return new Array(part1.length + 1).join('X') + '-' + part2;
  }

  render() {
    if (this.state.toMain === true) {
      return ( 
      <Redirect 
          to={'/external/home/' + this.props.match.params.shareuserid 
          + '/' + this.props.match.params.shareid}
      /> 
      );
    }
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };
    return (
      <div className="Login"> 
        <div className="container">
          <Row>
            <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            <Col xs={20} sm={16} md={12} lg={8} xl={6}>
              <div className="externalLogoContainer"><img className="logo" src={logo} /></div>
            </Col>
            <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
          </Row>
          <Row>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                <h2 className="twoStepVerif">{strings.lsTwoStepTxt}
                </h2>
                <h3 className="twoStepVerif" hidden={this.state.isMobileInput}>
                  {this.state.selected === 'email' ?
                    strings.lsEnterCode.split('mobile')[0] + ' Email'
                    : strings.lsEnterCode} </h3>
              </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
          </Row>
          {this.state.isMobileInput ? 
            <div className="usernameContainer" hidden={this.state.linkExpired}>
              <Row>
                <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
                <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                  <b style={{fontSize: 17}}>Send Verification Code to:</b>
                </Col>
                <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              </Row><br/>
              <Row>
                <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
                <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                <Radio.Group 
                    onChange={e => this.setState({
                      selected: e.target.value,
                      errorEmail: false,
                      errorMobile: false
                    })}
                    value={this.state.selected}
                >
                  {this.state.email.length > 0 &&
                    <Radio style={radioStyle} value="email">
                      {this.getFormattedValue('email')}
                    </Radio>
                  }<br/>
                  {this.state.mobileNum.length > 0 &&
                    <Radio style={radioStyle} value="phone">
                      {this.getFormattedValue('phone')}
                    </Radio>
                  }
                </Radio.Group>
                </Col>
                <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              </Row><br/>
              <Row>
                <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
                <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                {
                  this.state.selected === 'email' && this.state.errorEmail
                    && <Alert message={strings.lsEmailErrorTxt} type="error" />
                }
                {
                  this.state.selected === 'phone' && this.state.errorMobile
                    && <Alert message={strings.lsPhoneErrorTxt} type="error" />
                }
                </Col>
                <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              </Row>
            </div>
            :
          <div className="usernameContainer">

            <Row className="labelRow">
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                <span> {strings.lsOTPPlaceholderTxt} </span>
              </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            </Row>
            <Row>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col xs={20} sm={16} md={12} lg={8} xl={6}>
              
                <Input 
                    value={this.state.mobileotp}
                    onChange={ 
                      e => this.setState({mobileotp: e.target.value})}
                    prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    className={this.state.errorMotp ? 
                    'username errorHighlight' : 'username'}
                    disabled={this.state.inputDisabled}
                    name="otp"
                    id="otp"
                    autoFocus={true}
                />
              </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            </Row>
          </div>}
          
          <div className="forgotPasswordContainer"> 
            <Row>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                <Col xs={10} sm={10} md={10} lg={10} xl={10}/>
                <Col xs={14} sm={12} md={14} lg={14} xl={14} style={{textAlign: 'right'}}>
                  {this.state.isMobileInput ? '' :
                    this.state.counter === 60 ?
                      <a onClick={this.handleResendClick}> {strings.lsOTPResentTxt} </a>
                    : <span style={{color: 'grey'}}> {strings.lsOTPResentTxt} </span>
                  }
                </Col>
              </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            </Row>
            <Row>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                <Col xs={10} sm={10} md={10} lg={10} xl={10}/>
                <Col xs={14} sm={12} md={14} lg={14} xl={14} style={{textAlign: 'right'}}>
                  {
                    !this.state.isMobileInput && this.state.counter < 60
                    ? 'in ' + this.state.counter + ' seconds' : ''
                  }
                </Col>
              </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            </Row>
          </div>
          {/* {this.state.counter < 60 &&
            <Row>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                <Alert
                    message={'Resend verification code in ' + this.state.counter + ' seconds'}
                    type="info"
                />
              </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            </Row>} */}
          <div className="signinContainer" hidden={this.state.linkExpired}> 
            <Row>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col xs={20} sm={16} md={12} lg={8} xl={6}>
              {this.state.isMobileInput ? 
                  <Button 
                    className="signin" 
                    type="primary" 
                    loading={this.state.loading}
                    onClick={e => this.getMobileCode()}
                    disabled={this.state.freezeInput || this.state.counter < 60}
                  >
                    {strings.lsSendOTP}
                  </Button>
                :
                  <Button 
                    className="signin" 
                    type="primary" 
                    loading={this.state.loading}
                    onClick={e => this.submit()}
                  >
                    {strings.lsSignInTxt}
                  </Button> }
                </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            </Row><br/>
            <Row>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                <Col xs={10} sm={10} md={10} lg={10} xl={10}/>
                <Col xs={14} sm={12} md={14} lg={14} xl={14} style={{textAlign: 'right', color: '#1890ff'}}>
                  {this.state.isMobileInput && this.state.counter < 60 ?
                    'Wait for ' + this.state.counter + ' seconds to send code' : ''
                  }
                </Col>
              </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            </Row>
          </div>
        </div>
        { this.state.linkExpired ?
            <div className="linkExpired">
              <Alert 
                  banner={true} 
                  message={strings.lsLinkExpr}
                  description={strings.formatString(
                          strings.lsExpiredLinkMsg, 
                          this.state.userFirstName, 
                          this.state.userLastName, 
                          this.state.userOrgName)}
                  type="error" 
                  showIcon={true} 
              />
            </div> : '' }
        <div className="footer">
          {/* <Row>
            <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            <Col xs={7} sm={6} md={3} lg={3} xl={2} style={{textAlign: 'left'}}>
              <Link to="/privacy" className="footerLinks">{strings.lsPrivacyPolicyTxt}</Link>
            </Col>
            <Col xs={5} sm={5} md={3} lg={2} xl={2} style={{textAlign: 'center'}}>
              <Link to="/terms" className="footerLinks">{strings.lsTermsTxt}</Link>
            </Col>
            <Col xs={8} sm={5} md={6} lg={3} xl={2} style={{textAlign: 'right'}}>
              <Link to="/contactus" className="footerLinks">{strings.lsContactTxt}</Link>
            </Col>
            <Col xs={2} sm={4} md={6} lg={7} xl={9}/>
          </Row> */}
          <Row>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col 
                xs={20} 
                sm={16} 
                md={12} 
                lg={8} 
                xl={6} 
                className="footerLinks copyright"
              >
                  {strings.lsFooterCopyrightTxt}
              </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            </Row>
        </div>
      </div> 
    );
  }

  componentDidMount() {
    console.log(navigator.language);
    strings.setLanguage(navigator.language);
    storage.setSharedId('');
    storage.setSharedUserId('');
    // this.phoneInput.numberInputRef.focus();
    this.validateLink();
    let loginState: any = localStorage.getItem('loginState');
    console.log('loginState', loginState);
    loginState = JSON.parse(loginState);
    if (loginState && loginState.shareid === this.props.match.params.shareid) {
      let counter = 60;
      if (loginState.counter !== 60) {
        let diff = Math.floor((Date.now() - loginState.endTime) / 1000);
        counter = diff <= 0 ? Math.abs(diff) : 60;
      }
      console.log('counter', counter);
      // let isMobileInput = loginState.isMobileInput;
      this.setState(
        { counter },
        () => this.state.counter < 60 ? this.startCounter() : null
      );
    }
  }

  handleResendClick = () => {
    if (this.state.counter === 60) {
      this.generateOtp(GENERATEOTP_TYPE.resendOTP);
    }
  }

  startCounter = () => {
    timer = setInterval(
      () => {
        if (this.state.counter > 0) {
          this.setState({
            counter: this.state.counter - 1
          });
        } else {
          clearInterval(timer);
          this.setState({
            counter: 60
          });
        }
      },
      1000
    );
  }

  /**
   * Initializes local storage
   * @param res Server response when link is clicked
   */
  private initializeLocalstorage(res: any) {
    storage.setToken(res.token !== undefined ? res.token : '');   
    let tokenData = this.decodeToken(res.token);
    storage.setUserName(tokenData.firstname !== undefined ? tokenData.firstname : '');
    storage.setUser(tokenData.user !== undefined ? tokenData.user : '');
    localStorage.setItem('loginState', '{}');
  }

    /**
     * Validate input values provided by the user before submitting to server 
     */
    private validateInput(): boolean {
      let isValid: boolean = true;
      let errorMotp: boolean = false;
      this.state.mobileotp !== null && this.state.mobileotp.trim() === '' ?    
          errorMotp = true : errorMotp = false;
      if (errorMotp === true ) { isValid = false; } 
      this.setState({errorMotp, loading: false, inputDisabled: false});
      return isValid;
    }

    /**
     * Validates mobile number
     */
    // private validateMobileInput(): boolean {
    //   let isValid: boolean = true;
    //   let errorMobile: boolean = false;
    //   let errorEmail: boolean = false;
    //   // this.mobileNum.current !== null && this.mobileNum.current.input.value.trim() === '' ?    
    //   //   errorMobile = true : errorMobile = false;
    //   if (!this.state.mobileNum || this.state.mobileNum === '') {
    //     errorMobile = true;
    //   }
    //   if (!this.state.email || this.state.email === '') {
    //     errorEmail = true;
    //   }
    //   // this.state.mobileNum !== null && this.state.mobileNum === '' ?    
    //   //   errorMobile = true : errorMobile = false;
    //   if (errorMobile && errorEmail) {
    //     isValid = false;
    //   } 
    //   this.setState({errorMobile, errorEmail, loading: false, inputDisabled: false});
    //   return isValid;
    // }

    /**
     * Calls API to generate otp. 
     * Gets called when link is hit or resend button is clicked
     * @param type GENERATEOTP_TYPE constant
     */
    private async generateOtp(type: number) {
      let ser = new service();
      let shareuserid = this.props.match.params.shareuserid;
      let shareid = this.props.match.params.shareid;
      console.log('generateOtp', this.state.mobileNum);
      let email = this.state.selected === 'email' ? this.state.email : '';
      let phone = this.state.selected === 'phone' ? this.state.mobileNum : '';
      if (phone.length === 10) {
        phone = '1' + phone;
      }
      let resp = await ser.generateOTP(shareuserid, shareid, phone, email);
      if (type === GENERATEOTP_TYPE.resendOTP) {
        if (resp.status === 0) {
          message.success(strings.lsOTPResentSuccess, MSGDISPLAYTIME);
          this.startCounter();
        } else if (resp.message.indexOf('Maximum Limit') > -1) {
          message.error(strings.lsOTPMaxLimitTxt
                      , MSGDISPLAYTIME);
        } else {
          console.log('otp error');
          message.error(strings.lsOtpErrorTxt);
        }
      }
      if (type === GENERATEOTP_TYPE.sendOTP) {
        if (resp.status === 1) {
          console.log('otp error');
          // message.error(strings.lsOtpErrorTxt);
        }
        this.setState({
          isMobileInput: false
        });
      }
      console.log('generate resp', resp);
    }

    /**
     * Checks if link has expired or not
     */
    private async validateLink() {
      let ser = new service();
      let shareid = this.props.match.params.shareid;
      let userid = this.props.match.params.shareuserid;
      let profileShare = parseInt(this.props.match.params.flag, 10);
      let resp = await ser.validateLink(shareid);
      console.log('validateLink resp', resp);
      let path = window.location.href.split('external')[0];
      if (resp.status === 0) {
        let result = await ser.getUserByShareId(userid, shareid, profileShare);
        if (result.length > 0) {
          let shareuser = result[0];
          console.log('shareuser', result);
          if (shareuser !== undefined) {
            if (shareuser.email || shareuser.phone) {
              this.setState({
                email: shareuser.email ? shareuser.email : '',
                mobileNum: shareuser.phone ? shareuser.phone : '',
                selected: shareuser.email ? 'email' : 'phone'
              });
            } else {
              window.location.href = path + 'unauthorized/2';
            }
            return true;
          } else  { return false; }
        } else {
          window.location.href = path + 'unauthorized/2';
          return false;
        }
      } else if (resp.status === 1 && resp.message.indexOf('Link Expired') > -1) {
        this.setState({
          linkExpired: true,
          userFirstName: resp.firstname,
          userLastName: resp.lastname,
          userOrgName: resp.organizationname
        });
        // message.error(strings.lsLinkExpired, MSGDISPLAYTIME);
        return false;
      } else {
        window.location.href = path + 'unauthorized/2';
        return false;
      }
     // console.log('generate respo', resp);
    }

    /**
     * Decodes the token
     * @param token Session Token
     */
    private decodeToken(token: any) {
      if (token !== undefined) {
        let base64Url = token.split('.')[1];   
        let base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
      }
    }

    /**
     * This function gets called when mobile input value if changed
     * @param value 
     */
    private handleOnChange(value: string) {
      console.log('handleonchange', value);
      let formatValue = value.replace(/\D/g, '');
      console.log('formatValue', formatValue);
      this.setState({
          mobileNum: value,
          mobileNumFormatted: formatValue
      });
  }

}

export default ExternalLogin;


// WEBPACK FOOTER //
// ./src/components/external/Login.tsx